export const FLAG_ON = 1;
export const MAX_RECORDS_IN_PAGE = 1000;
export const OPEN_FLAG_OPEN = 1;
export const OPEN_FLAG_CLOSE = 0;
export const CATEGORY_KIND_GROUP_CLASS = 2;
export const CATEGORY_KIND_GROUP_GROUP = 7;
export const RECORDS_IN_PAGE_PARAMETER_NAME = 'perpage';
